import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("azv-session-expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Algo deu errado. Tente novamente.") {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Sem conexão com o servidor. Verifique sua internet.";
  if (d == null) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-BR") : "—");
export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "—";
export const brl = (v) => (v == null ? "—" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));
export const URGENCY = { normal: "Normal", prioritaria: "Prioritária", urgente: "Urgente" };
export const MODALITY = { pf: "Pessoa Física", recorrente: "Consultoria recorrente", pontual: "Demanda pontual" };
export const waLink = (phone, text = "") => {
  const d = (phone || "").replace(/\D/g, "");
  return `https://wa.me/55${d}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};
